export default {
  title: 'Easy Air Screen',
  subtitle: 'Превратите свой планшет в беспроводной второй монитор',
  description: 'Превратите свой планшет в высококачественный беспроводной дисплей для macOS. Расширьте рабочее пространство и повысьте продуктивность—кабели не нужны.',
  downloadMobile: 'Скачать Мобильное Приложение',
  purchasePromise: 'Разовая покупка. Без подписки и рекламы.',
  companionPromise: 'Приложение для Mac бесплатное, учетная запись не нужна.',
  downloadMacOS: 'Скачать для macOS (Universal)',
  quickSetup: 'Быстрая Настройка',
  setupSteps: [
    'Установите Easy Air Screen на свой планшет',
    'Скачайте и установите десктопное приложение для macOS',
    'Подключите оба устройства к одной сети Wi-Fi',
    'Запустите и подключите!'
  ],
  performanceTip: 'Совет по Производительности',
  performanceDescription: 'Для лучшего опыта с минимальной задержкой используйте Wi-Fi-соединение 5 ГГц на обоих устройствах. Если заметите задержку, попробуйте уменьшить разрешение в настройках приложения.',
  faqTitle: 'Частые вопросы',
  faq: [
    {
      q: 'Чем это отличается от Sidecar?',
      a: 'Easy Air Screen работает, даже если на устройствах используются разные Apple ID. Также можно использовать Android-планшет как беспроводной второй экран для Mac.'
    },
    {
      q: 'Можно ли использовать Android-планшет?',
      a: 'Да. Android-планшет можно использовать как беспроводной второй экран для Mac. Подключите оба устройства к одной сети Wi-Fi, чтобы расширить или дублировать экран.'
    },
    {
      q: 'Можно ли использовать iPhone как второй экран?',
      a: 'Да. iPhone можно использовать как беспроводной второй экран для Mac. При подключении выберите расширение рабочего стола или дублирование экрана.'
    },
    {
      q: 'Экран расширяется или дублируется?',
      a: 'Поддерживаются оба режима. Можно расширить рабочий стол Mac на другой экран или дублировать текущий экран, чтобы на устройствах было одинаковое изображение.'
    },
    {
      q: 'Нужен ли интернет? Экран передаётся наружу?',
      a: 'Интернет не нужен. Устройства подключаются напрямую в одной сети Wi-Fi, а экран не проходит через внешний сервер и не сохраняется на нём.'
    },
    {
      q: 'Это подписка?',
      a: 'Нет. Приложение для устройства покупается один раз, это не подписка и в нём нет рекламы. Приложение-компаньон для Mac бесплатно и не требует учётной записи.'
    },
    {
      q: 'Работает ли это на Windows PC?',
      a: 'Нет. Easy Air Screen предназначен только для macOS. Windows PC сейчас не поддерживается.'
    },
    {
      q: 'Что делать, если экран тормозит или прерывается?',
      a: 'По возможности подключите оба устройства к сети Wi-Fi 5GHz. Если задержка остаётся, уменьшите разрешение в настройках приложения.'
    },
  ]
};
